import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import CopyToClipboard from 'react-copy-to-clipboard'
import {MenuPosition} from '../hooks/useCoords'
import useTooltip from '../hooks/useTooltip'









const CopyLink = (props) => {
  const {title, children, tooltip, url, onCopy} = props
  const {tooltipPortal, openTooltip, closeTooltip, originRef} = useTooltip(
    MenuPosition.LOWER_CENTER
  )

  const handleCopy = () => {
    if (tooltip) {
      openTooltip()
      setTimeout(() => {
        closeTooltip()
      }, 2000)
    }

    onCopy && onCopy()
  }
  return (
    _jsxs(_Fragment, { children: [
      _jsx(CopyToClipboard, { text: url, onCopy: handleCopy, title: title, children: 
        _jsx('span', { ref: originRef, children: children})
      })
      , tooltipPortal(tooltip)
    ]})
  )
}

export default CopyLink
